import { createAction, props } from '@ngrx/store';
import { NavigationItem } from './navigation.reducer';

// Action types
export const loadNavigation = createAction(
    '[Navigation] Load Navigation'
);

export const loadNavigationSuccess = createAction(
    '[Navigation] Load Navigation Success',
    props<{ navigationItems: NavigationItem[] }>()
);

export const loadNavigationFail = createAction(
    '[Navigation] Load Navigation Fail',
    props<{ error: any }>()
);
